// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"5d12213d80cec28fc891","873":"0247dbf51a9319786e47"}[chunkId] + ".js";
};